import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

// To use it in the interceptor, export a function to navigate
export const navigateTo = (path) => {
    history.push(path);
};